import { jsx } from "react/jsx-runtime";
import { ApexSubmit } from "@zillow/zrs-cms";
import PropTypes from "prop-types";
import "react";
const BUTTON_TYPE_MAP = {
  primary: {
    tone: "brand",
    emphasis: "filled"
  },
  secondary: {
    tone: "brand",
    emphasis: "outlined"
  },
  tertiary: {
    tone: "neutral",
    emphasis: "outlined"
  },
  caution: {
    tone: "critical",
    emphasis: "filled"
  }
};
const BlockApexSubmit = ({
  attrs
}) => {
  const {
    content,
    // v8 legacy props - resolved to tone/emphasis/onImpact below, stripped
    // from the DOM
    buttonType = "primary",
    inverse,
    // WordPress editor-only attr - must not reach the DOM
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    lock,
    // v10 props - win field-by-field if already stored
    tone,
    emphasis,
    onImpact,
    ...restAttrs
  } = attrs;
  const resolvedOnImpact = onImpact ?? (inverse || false);
  const legacyToneEmphasis = BUTTON_TYPE_MAP[buttonType] || BUTTON_TYPE_MAP.primary;
  const resolvedToneEmphasis = {
    tone: tone ?? legacyToneEmphasis.tone,
    emphasis: emphasis ?? legacyToneEmphasis.emphasis
  };
  if (resolvedOnImpact && tone === void 0 && emphasis === void 0 && resolvedToneEmphasis.tone === "brand" && resolvedToneEmphasis.emphasis === "outlined") {
    resolvedToneEmphasis.tone = "neutral";
  }
  return /* @__PURE__ */ jsx(ApexSubmit, { ...restAttrs, ...resolvedToneEmphasis, onImpact: resolvedOnImpact, children: content });
};
BlockApexSubmit.propTypes = {
  index: PropTypes.number,
  attrs: PropTypes.shape({})
};
export {
  BlockApexSubmit as default
};
